import { render } from "./PfSettings.vue?vue&type=template&id=64414570"
import script from "./PfSettings.vue?vue&type=script&lang=js"
export * from "./PfSettings.vue?vue&type=script&lang=js"

import "./PfSettings.vue?vue&type=style&index=0&id=64414570&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__